import { render, staticRenderFns } from "./groupFitnessDashboardCourses.vue?vue&type=template&id=5138f050&scoped=true"
import script from "./groupFitnessDashboardCourses.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardCourses.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardCourses.vue?vue&type=style&index=0&id=5138f050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138f050",
  null
  
)

export default component.exports